import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header({ darkMode, setDarkMode }) {
  return (
    <header className="header">
      <a href="https://x.com/Loopify" target="_blank" rel="noopener noreferrer" className="x-logo-link">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      </a>
      <Link to="/" className="logo">
        loopify
      </Link>
      <button
        onClick={() => setDarkMode(prev => !prev)}
        className="dark-mode-toggle"
        aria-label="Toggle dark mode"
      >
        {darkMode ? (
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          </svg>
        )}
      </button>
    </header>
  );
}

export default Header;
